<template>
    <div class="p-5 sm:flex sm:items-center sm:justify-between mb-10 bg-white rounded-lg">
        <h1 class="text-gray-800 text-3xl tracking-widest">
            <slot></slot>
        </h1>
        <div class="mt-3 flex justify around sm:mt-0 sm:ml-4">
            <slot name="more"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Headline"
}
</script>

<style scoped>

</style>
